//dev
//const api_base = "http://localhost:24321"
//uat
const api_base = "https://uat-api.smart-q.com"
//pattaya
//const api_base = "https://backendappointment.pattayaconnect.net"
//prd
//const api_base = "https://api.smart-q.com"

module.exports = {
    manaul_file : 'https://drive.google.com/u/3/uc?id=1nIPZt1w6PavppY4kM0sau2iuOx-bUDYE&export=download'
    ,title : '9MANAD UAT : APPOINTMENT MANAGER'
    //,logo : ''
    //pattaya
    //manaul_file : 'https://drive.google.com/u/3/uc?id=1kollFmuglQfyixemfpUtkEV9h0fwnc0t&export=download'
    //,title : 'PATTAYA CONNECT : APPOINTMENT MANAGER'
    //,logo : 'https://storage.googleapis.com/smartqserver-app/reservation/app/5/logo.jpg'
    /*manaul_file : 'https://drive.google.com/u/3/uc?id=1nIPZt1w6PavppY4kM0sau2iuOx-bUDYE&export=download'
    ,title : '9MANAD : APPOINTMENT MANAGER'*/
    ,logo : ''
    ,api : {
        url : {
            public : {

                login : api_base + '/public/manage/login',
                get_datemasklist : api_base +  '/public/get/datemasklist',
                
                station : {
                    get_registerform : api_base + '/public/station/get/registerform'
                    ,get_activateqrcode : api_base + '/public/station/get/activateqrcode'
                },
                appointment : {
                    //get_grouplist : api_base + "/public/appointment/get/grouplist"
                    get_groupextranotelist : api_base + "/public/appointment/get/groupextranotelist"
                },
                redirect : {
                    line_station : api_base + "/public/redirect/line/station/"
                }
            },
            manage : {
                staff : {
                    get_stafflist : api_base + '/manage/staff/get/stafflist'
                    ,add_staff : api_base + '/manage/staff/add/staff'
                    ,get_permission : api_base + '/manage/staff/get/permission'
                    ,del_staff : api_base + '/manage/staff/del/staff'
                    ,update_savesession : api_base + '/manage/staff/update/savesession'
                    ,get_savesession : api_base + '/manage/staff/get/savesession'
                    ,update_force_new_password : api_base + '/manage/staff/update/forcenewpassword'
                    ,update_force_new_email : api_base + '/manage/staff/update/forcenewemail'
                },
                member : {
                    get_registerlist : api_base + '/manage/member/get/registerlist'
                    ,get_candidatelist : api_base + '/manage/member/get/candidatelist'
                    ,add_member : api_base + '/manage/member/add/member'
                    ,edit_member : api_base + '/manage/member/edit/member'
                    ,search_memberlist_stationcode : api_base + '/manage/member/search/memberlist/stationcode'
                    ,get_memberform :api_base + '/manage/member/get/memberform'
                    ,del_register :api_base + '/manage/member/del/register'
                    ,search_registerlist :api_base + '/manage/member/search/registerlist'
                    ,search_candidatelist :api_base + '/manage/member/search/candidatelist'
                },
                save : {
                    config : api_base + '/manage/save/config'
                },
                station : {
                    get_stationlist : api_base + '/manage/station/get/stationlist'
                    ,get_stationdetail : api_base + '/manage/station/get/stationdetail'
                    ,add_image : api_base +  '/manage/station/add/image'
                    ,add_station : api_base +  '/manage/station/add/station' 
                    ,del_station : api_base +  '/manage/station/del/station' 
                    ,get_notimessage : api_base +  '/manage/station/get/notimessage' 
                }
                ,appointment : {
                    manage : {
                        search_calendar : api_base + '/manage/appointment/manage/search/calendar' 
                        ,appointmentlistsize : api_base + '/manage/appointment/manage/search/appointmentlistsize' 
                        ,appointmentlist : api_base + '/manage/appointment/manage/search/appointmentlist' 
                        ,add_appointment : api_base + '/manage/appointment/manage/add/appointment' 
                        ,edit_status : api_base + '/manage/appointment/manage/edit/status' 
                        ,edit_date : api_base + '/manage/appointment/manage/edit/date' 
                        ,edit_station : api_base + '/manage/appointment/manage/edit/station' 
                        ,edit_callback_callwait : api_base + '/manage/appointment/manage/edit/callback/callwait' 
                        ,get_calendar : api_base + '/manage/appointment/manage/get/calendar'
                        ,get_timeslot : api_base + '/manage/appointment/manage/get/timeslot'
                        ,get_appointmentlog : api_base + '/manage/appointment/manage/get/appointmentlog'
                        ,get_grouplist : api_base + '/manage/appointment/manage/get/grouplist'
                    }
                    ,group : {
                        get_groupdetail : api_base + '/manage/appointment/group/get/groupdetail' 
                        ,get_grouprulepolicy : api_base + '/manage/appointment/group/get/grouprulepolicy' 
                        ,get_groupdatedetail : api_base + '/manage//appointment/group/get/groupdatedetail'
                        ,add_groupslot : api_base + '/manage/appointment/group/add/groupslot'
                        ,del_groupslot : api_base + '/manage/appointment/group/del/groupslot'
                        ,add_generalclosetag : api_base + '/manage/appointment/group/add/generalclosetag'
                        ,del_generalclosetag : api_base + '/manage/appointment/group/del/generalclosetag'
                        ,add_group : api_base + '/manage/appointment/group/add/group'
                        ,edit_extradate : api_base + '/manage/appointment/group/edit/extradate'
                        ,add_groupslotappointment : api_base + '/manage/appointment/group/add/groupslotappointment'
                        ,del_groupslotappointment : api_base + '/manage/appointment/group/del/groupslotappointment'
                    }
                }
                ,noti : {
                    noti_remind : api_base + '/manage/noti/noti/remind'
                    ,noti_allstaff : api_base + '/manage/noti/noti/allstaff'
                }
                ,dashboard : {
                    get_activatestatold : api_base + '/manage/dashboard/get/activatestatold'
                    ,get_activatestat : api_base + '/manage/dashboard/get/activatestat'
                    ,get_memberstat : api_base + '/manage/dashboard/get/memberstat'
                    ,get_acceptstat : api_base + '/manage/dashboard/get/acceptstat'
                    ,get_holdstat : api_base + '/manage/dashboard/get/holdstat'
                    ,get_notistat : api_base + '/manage/dashboard/get/notistat'
                    ,get_appointmentmanagestat : api_base + '/manage/dashboard/get/appointmentmanagestat'
                    ,get_stafflog : api_base + '/manage/dashboard/get/stafflog'
                }
                ,specialmarket : {
                    get_setting : api_base + '/manage/special/market/get/setting'
                    ,add_product : api_base + '/manage/special/market/add/product'
                    ,update_orderlimit : api_base + '/manage/special/market/update/orderlimit'
                    ,update_price : api_base + '/manage/special/market/update/price'
                    ,get_orderlist : api_base + '/manage/special/market/get/orderlist'
                }
                , package: {
                    list_package: api_base + '/manage/package'
                    , insert_package: api_base + '/manage/package'
                    , update_package: api_base + '/manage/package/'
                    , delete_package: api_base + '/manage/package/delete/'
                }, ext_package: {
                    list_ext_package: api_base + '/manage/extpackage'
                    , list_ext_package_by_type: api_base + '/manage/extpackage/'
                    , insert_ext_package: api_base + '/manage/extpackage'
                    , update_ext_package: api_base + '/manage/extpackage/'
                    , delete_ext_package: api_base + '/manage/extpackage/delete/'
                }, customerpackage : {
                    list: api_base + '/manage/customerpackage'
                    , get: api_base + '/manage/customerpackage/'
                    , insert_customer_package: api_base + '/manage/customerpackage'
                    , update_customer_package: api_base + '/manage/customerpackage/'
                    , list_customer: api_base + '/manage/customerpackage/station'
                    , delete_customer_package: api_base + '/manage/customerpackage/delete/'
                },
                    dropdown: {
                    unit: api_base + '/manage/dropdown/unit'
                },
                    customer: {
                    list: api_base + '/manage/customer',
                    get: api_base + '/manage/customer/',
                    customerbystationcode: api_base + '/manage/customer/stationcode',
                    insert: api_base + '/manage/customer',
                    update: api_base + '/manage/customer/',
                    delete: api_base + '/manage/customer/delete/',
                }
            }
        }
    }
}